<!-- <ng-container *ngIf="_currentComponentName && FormObject; else componentNameNotAvailable"> -->
  <nz-skeleton [nzAvatar]="false" [nzActive]="true" [nzTitle]="true" [nzLoading]="fetchingFormData">
    <ng-container *ngIf="metaDataValid && FormObject && rulesExecutionMetaData">
      <nz-collapse [nzBordered]="false" class="panel-custom-unified">
        <nz-collapse-panel [nzActive]="true" [nzHeader]="FORMTITLE ? expanded : ''" [ngStyle]="panelCustomStyle" [nzShowArrow]="showArrow"
          [nzDisabled]="!enableCollapse" [nzExpandedIcon]="panelIcon||undefined">
          <ng-template #expanded let-active>
  
            <div *ngIf="FORMTITLE" class="heading-tab panel-custom-unified-collapse-heading">
              <h3 class="heading"><i nz-icon [nzType]="formIcon"></i> {{FORMTITLE | translate}}</h3>
            </div>
          </ng-template>
          <form [formGroup]="FormObject">
            <div [ngClass]="gridClass" class="tab-grid m-t-20">
              <ng-container *ngFor="let fieldControl of FORMMETADATAFACTORY; let fieldIndex = index">
                <div *ngIf="!fieldControl.hidden" [ngSwitch]="fieldControl.fieldType"
                  [class.inputs-are-disabled]="fieldControl.disabled"
                  [class.textarea-full-width]="fieldControl.fieldType==='TEXTAREA'"
                  [class.bigInput-width]="fieldControl.fieldType==='BIGINPUT'"
                  [ngStyle]="{
                    'grid-row-start':fieldControl.layoutRow,
                    'grid-column-start':fieldControl.layoutColStart,'grid-column-end':fieldControl.layoutColEnd?fieldControl.layoutColEnd+1:'',
                    'grid-column-': fieldControl.layoutColStart?'' + fieldControl.layoutColStart + '/' + fieldControl.layoutColEnd:''
                    }">
                  <div *ngSwitchCase="'COMBO'">
                    <nz-form-item>
                      <nz-form-label [nzFor]="fieldControl.fieldKey" [nzSpan]="24"
                        [nzRequired]="isRequired(fieldControl.fieldKey)">{{fieldControl.fieldName | translate}}<span
                          class="p-l-5 col-grey-light" nz-tooltip [nzTooltipTitle]="fieldControl.fieldDesc"
                          *ngIf="fieldControl.fieldDesc"><i nz-icon nzType="exclamation-circle"
                            class="ico-item"></i></span> <span
                          *ngIf="!fieldControl.ignoreSpellCheck && !environment.production" nz-tooltip
                          [nzTooltipTitle]="fieldControl.wrongSpellWords"
                          style="font-size: small; color: red;">{{fieldControl.fieldNameSpellCheckCorrent? '' : '[Wrong
                          Spelling]'}}</span>
                      </nz-form-label>
                      <nz-form-control [nzSpan]="24">
                        <nz-select nzShowSearch nzAllowClear
                          [nzMode]="fieldControl.comboMode? fieldControl.comboMode : 'default'"
                          [id]="fieldControl.fieldKey" [formControlName]="fieldControl.fieldKey"
                          (ngModelChange)="fieldDataChangeHandler(fieldControl.fieldGenericMapping,fieldControl.fieldKey)"
                          [nzDisabled]="disabled || fieldControl.disabled" style="width: 100%">
                          <ng-container *ngIf="lookupLoadingMode == 'bySubject';else showByDataForCombo">
                            <nz-option
                              *ngFor="let item of (lookup$[fieldControl.lookupCd] | async) as LookupList; trackBy:item?.lookupKey"
                              [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                          </ng-container>
                          <ng-template #showByDataForCombo>
                            <ng-container *ngIf="lookupData[fieldControl.lookupCd]">
                              <nz-option
                                *ngFor="let item of (lookupData[fieldControl.lookupCd]) as LookupList; trackBy:item?.lookupKey"
                                [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                            </ng-container>
                          </ng-template>
                        </nz-select>
                        <!--  -->
                        <ng-container
                          *ngIf="FormObject.get(fieldControl.fieldKey) && (FormObject.get(fieldControl.fieldKey).dirty || FormObject.get(fieldControl.fieldKey).touched) && FormObject.get(fieldControl.fieldKey).errors">
                          <p style="color:red; margin-top:5px;"
                            *ngFor="let error of validationUtilService.getUIErrorList(FormObject.get(fieldControl.fieldKey), FORMNAME)">
                            {{error? error.errorMessage : 'Invalid Data' }}</p>
                        </ng-container>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div *ngSwitchCase="'COMBOMULTISELECTCSV'">
                    <nz-form-item>
                      <nz-form-label [nzFor]="fieldControl.fieldKey" [nzSpan]="24"
                        [nzRequired]="isRequired(fieldControl.fieldKey)">{{fieldControl.fieldName | translate}}<span
                          class="p-l-5 col-grey-light" nz-tooltip [nzTooltipTitle]="fieldControl.fieldDesc"><i nz-icon
                            nzType="exclamation-circle" class="ico-item"></i></span> <span
                          *ngIf="!fieldControl.ignoreSpellCheck && !environment.production" nz-tooltip
                          [nzTitle]="fieldControl.wrongSpellWords"
                          style="font-size: small; color: red;">{{fieldControl.fieldNameSpellCheckCorrent? '' : '[Wrong
                          Spelling]'}}</span>
                      </nz-form-label>
                      <nz-form-control [nzSpan]="24">
                        <nz-select nzShowSearch nzAllowClear [nzMode]="'tags'" [id]="fieldControl.fieldKey"
                          [formControlName]="fieldControl.fieldKey"
                          (ngModelChange)="fieldDataChangeHandler(fieldControl.fieldGenericMapping,fieldControl.fieldKey)"
                          [nzDisabled]="disabled || fieldControl.disabled" style="width: 100%">
                          <nz-option
                            *ngFor="let item of (lookup$[fieldControl.lookupCd] | async) as LookupList; trackBy:item?.lookupKey"
                            [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                        </nz-select>
                        <!--  -->
                        <ng-container
                          *ngIf="FormObject.get(fieldControl.fieldKey) && (FormObject.get(fieldControl.fieldKey).dirty || FormObject.get(fieldControl.fieldKey).touched) && FormObject.get(fieldControl.fieldKey).errors">
                          <p style="color:red; margin-top:5px;"
                            *ngFor="let error of validationUtilService.getUIErrorList(FormObject.get(fieldControl.fieldKey), FORMNAME)">
                            {{error? error.errorMessage : 'Invalid Data' }}</p>
                        </ng-container>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div *ngSwitchCase="'COMBOMULTISELECTENTERABLECSV'">
                    <nz-form-item>
                      <nz-form-label [nzFor]="fieldControl.fieldKey" [nzSpan]="24"
                        [nzRequired]="isRequired(fieldControl.fieldKey)">{{fieldControl.fieldName | translate}} <span
                          *ngIf="!fieldControl.ignoreSpellCheck && !environment.production" nz-tooltip
                          [nzTooltipTitle]="fieldControl.wrongSpellWords"
                          style="font-size: small; color: red;">{{fieldControl.fieldNameSpellCheckCorrent? '' : '[Wrong
                          Spelling]'}}</span>
                      </nz-form-label>
                      <nz-form-control [nzSpan]="24">
                        <nz-select nzShowSearch nzAllowClear [nzMode]="'multiple'" [id]="fieldControl.fieldKey"
                          [formControlName]="fieldControl.fieldKey"
                          (ngModelChange)="fieldDataChangeHandler(fieldControl.fieldGenericMapping,fieldControl.fieldKey)"
                          [nzDisabled]="disabled || fieldControl.disabled" style="width: 100%">
                          <nz-option
                            *ngFor="let item of (lookup$[fieldControl.lookupCd] | async) as LookupList; trackBy:item?.lookupKey"
                            [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                        </nz-select>
                        <!--  -->
                        <ng-container
                          *ngIf="FormObject.get(fieldControl.fieldKey) && (FormObject.get(fieldControl.fieldKey).dirty || FormObject.get(fieldControl.fieldKey).touched) && FormObject.get(fieldControl.fieldKey).errors">
                          <p style="color:red; margin-top:5px;"
                            *ngFor="let error of validationUtilService.getUIErrorList(FormObject.get(fieldControl.fieldKey), FORMNAME)">
                            {{error? error.errorMessage : 'Invalid Data' }}</p>
                        </ng-container>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div *ngSwitchCase="'DATE'">
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24" [nzRequired]="isRequired(fieldControl.fieldKey)">
                        {{fieldControl.fieldName | translate}}<span class="p-l-5 col-grey-light" nz-tooltip
                          [nzTooltipTitle]="fieldControl.fieldDesc" *ngIf="fieldControl.fieldDesc"><i nz-icon
                            nzType="exclamation-circle" class="ico-item"></i></span> <span
                          *ngIf="!fieldControl.ignoreSpellCheck && !environment.production" nz-tooltip
                          [nzTooltipTitle]="fieldControl.wrongSpellWords"
                          style="font-size: small; color: red;">{{fieldControl.fieldNameSpellCheckCorrent? '' : '[Wrong
                          Spelling]'}}</span>
                      </nz-form-label>
                      <nz-form-control [nzSpan]="24">
                        <nz-date-picker nzShowTime [id]="fieldControl.fieldKey" [formControlName]="fieldControl.fieldKey"
                          (ngModelChange)="fieldDataChangeHandler(fieldControl.fieldGenericMapping,fieldControl.fieldKey)"
                          [nzDisabled]="disabled || fieldControl.disabled"
                          [nzFormat]="fieldControl.format || appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR">
                        </nz-date-picker>
                        <ng-container
                          *ngIf="FormObject.get(fieldControl.fieldKey) && (FormObject.get(fieldControl.fieldKey).dirty || FormObject.get(fieldControl.fieldKey).touched) && FormObject.get(fieldControl.fieldKey).errors">
                          <p style="color:red; margin-top:5px;"
                            *ngFor="let error of validationUtilService.getUIErrorList(FormObject.get(fieldControl.fieldKey), FORMNAME)">
                            {{error? error.errorMessage : 'Invalid Data' }}</p>
                        </ng-container>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div *ngSwitchCase="'INPUT'">
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24"
                        [nzRequired]="true">{{fieldControl.fieldName |
                        translate}} <span class="p-l-5 col-grey-light" nz-tooltip
                          [nzTooltipTitle]="fieldControl.fieldDesc" *ngIf="fieldControl.fieldDesc"><i nz-icon
                            nzType="exclamation-circle" class="ico-item"></i></span> <span
                          *ngIf="!fieldControl.ignoreSpellCheck && !environment.production" nz-tooltip
                          [nzTooltipTitle]="fieldControl.wrongSpellWords"
                          style="font-size: small; color: red;">{{fieldControl.fieldNameSpellCheckCorrent? '' : '[Wrong
                          Spelling]'}}</span>
                      </nz-form-label>
                      <nz-form-control [nzSpan]="24">
                        <input nz-input [formControlName]="fieldControl.fieldKey"
                          (ngModelChange)="fieldDataChangeHandler(fieldControl.fieldGenericMapping,fieldControl.fieldKey)"
                          disabled="disabled || fieldControl.disabled || fieldControl.readOnly" [maxlength]="fieldControl.maxlength"/>
                        <ng-container
                          *ngIf="FormObject.get(fieldControl.fieldKey) && (FormObject.get(fieldControl.fieldKey).dirty || FormObject.get(fieldControl.fieldKey).touched) && FormObject.get(fieldControl.fieldKey).errors">
                          <p style="color:red; margin-top:5px;"
                            *ngFor="let error of validationUtilService.getUIErrorList(FormObject.get(fieldControl.fieldKey), FORMNAME)">
                            {{error? error.errorMessage : 'Invalid Data' }}</p>
                        </ng-container>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div *ngSwitchCase="'SLIDER'">
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24"
                        [nzRequired]="true">{{fieldControl.fieldName |
                        translate}} <span class="p-l-5 col-grey-light" nz-tooltip
                          [nzTooltipTitle]="fieldControl.fieldDesc" *ngIf="fieldControl.fieldDesc"><i nz-icon
                            nzType="exclamation-circle" class="ico-item"></i></span> <span
                          *ngIf="!fieldControl.ignoreSpellCheck && !environment.production" nz-tooltip
                          [nzTooltipTitle]="fieldControl.wrongSpellWords"
                          style="font-size: small; color: red;">{{fieldControl.fieldNameSpellCheckCorrent? '' : '[Wrong
                          Spelling]'}}</span>
                      </nz-form-label>
                      <nz-form-control [nzSpan]="24">
                        <nz-slider [nzMin]="fieldControl.min || '0'" [nzMax]="fieldControl.max || '100'" [nzStep]="fieldControl.step || '1'" 
                          [formControlName]="fieldControl.fieldKey" [nzDisabled]="fieldControl.disabled"
                          (ngModelChange)="fieldDataChangeHandler(fieldControl.fieldGenericMapping,fieldControl.fieldKey)"></nz-slider>
                          <!-- <div>
                            <nz-input-number [nzMin]="fieldControl.min || '0'" [nzMax]="fieldControl.max || '100'" [nzStep]="fieldControl.step || '1'"
                              [ngStyle]="{ marginLeft: '16px' }" 
                              [formControlName]="fieldControl.fieldKey" [nzDisabled]="fieldControl.disabled"></nz-input-number>
                          </div> -->
                        <ng-container
                          *ngIf="FormObject.get(fieldControl.fieldKey) && (FormObject.get(fieldControl.fieldKey).dirty || FormObject.get(fieldControl.fieldKey).touched) && FormObject.get(fieldControl.fieldKey).errors">
                          <p style="color:red; margin-top:5px;"
                            *ngFor="let error of validationUtilService.getUIErrorList(FormObject.get(fieldControl.fieldKey), FORMNAME)">
                            {{error? error.errorMessage : 'Invalid Data' }}</p>
                        </ng-container>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div *ngSwitchCase="'TAG'">
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24">{{fieldControl.fieldName | translate}}<span
                          class="p-l-5 col-grey-light" nz-tooltip [nzTooltipTitle]="fieldControl.fieldDesc"
                          *ngIf="fieldControl.fieldDesc"><i nz-icon nzType="exclamation-circle"
                            class="ico-item"></i></span> <span
                          *ngIf="!fieldControl.ignoreSpellCheck && !environment.production" nz-tooltip
                          [nzTooltipTitle]="fieldControl.wrongSpellWords"
                          style="font-size: small; color: red;">{{fieldControl.fieldNameSpellCheckCorrent? '' : '[Wrong
                          Spelling]'}}</span>
                      </nz-form-label>
                      <nz-form-control [nzSpan]="24">
                        <nz-tag *ngIf="FormObject?.value[fieldControl.fieldKey]" [nzColor]="'#108ee9'">
                          {{FormObject?.value[fieldControl.fieldKey] | technicalTranslate}}
                        </nz-tag>
                        <p *ngIf="!FormObject?.value[fieldControl.fieldKey]"> - </p>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div *ngSwitchCase="'MASKEDINPUT'">
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24"
                        [nzRequired]="isRequired(fieldControl.fieldKey)">{{fieldControl.fieldName |
                        translate}}<span class="p-l-5 col-grey-light" nz-tooltip [nzTooltipTitle]="fieldControl.fieldDesc"
                          *ngIf="fieldControl.fieldDesc"><i nz-icon nzType="exclamation-circle"
                            class="ico-item"></i></span> <span
                          *ngIf="!fieldControl.ignoreSpellCheck && !environment.production" nz-tooltip
                          [nzTooltipTitle]="fieldControl.wrongSpellWords"
                          style="font-size: small; color: red;">{{fieldControl.fieldNameSpellCheckCorrent? '' : '[Wrong
                          Spelling]'}}</span>
                      </nz-form-label>
                      <nz-form-control [nzSpan]="24">
                        <input nz-input [formControlName]="fieldControl.fieldKey" [maxlength]="fieldControl.maxlength"
                          (ngModelChange)="fieldDataChangeHandler(fieldControl.fieldGenericMapping,fieldControl.fieldKey)"
                          [mask]="fieldControl.mask" [readonly]="disabled || fieldControl.disabled" />
                        <ng-container
                          *ngIf="FormObject.get(fieldControl.fieldKey) && (FormObject.get(fieldControl.fieldKey).dirty || FormObject.get(fieldControl.fieldKey).touched) && FormObject.get(fieldControl.fieldKey).errors">
                          <p style="color:red; margin-top:5px;"
                            *ngFor="let error of validationUtilService.getUIErrorList(FormObject.get(fieldControl.fieldKey), FORMNAME)">
                            {{error? error.errorMessage : 'Invalid Data' }}</p>
                        </ng-container>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div *ngSwitchCase="'NUMBERINPUT' || 'NUMBER'">
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24"
                        [nzRequired]="isRequired(fieldControl.fieldKey)">{{fieldControl.fieldName |
                        translate}}<span class="p-l-5 col-grey-light" nz-tooltip [nzTooltipTitle]="fieldControl.fieldDesc"
                          *ngIf="fieldControl.fieldDesc"><i nz-icon nzType="exclamation-circle"
                            class="ico-item"></i></span> <span
                          *ngIf="!fieldControl.ignoreSpellCheck && !environment.production" nz-tooltip
                          [nzTooltipTitle]="fieldControl.wrongSpellWords"
                          style="font-size: small; color: red;">{{fieldControl.fieldNameSpellCheckCorrent? '' : '[Wrong
                          Spelling]'}}</span>
                      </nz-form-label>
                      <nz-form-control [nzSpan]="24">
                        <nz-input-number [formControlName]="fieldControl.fieldKey" [nzMin]="fieldControl.minValue || 0" [nzStep]="1" [nzMax]="fieldControl.maxValue || 999999999999999999999999"
                          (ngModelChange)="fieldDataChangeHandler(fieldControl.fieldGenericMapping,fieldControl.fieldKey)"
                          [nzDisabled]="disabled || fieldControl.disabled" style="width: 100%;"></nz-input-number>
                        <ng-container
                          *ngIf="FormObject.get(fieldControl.fieldKey) && (FormObject.get(fieldControl.fieldKey).dirty || FormObject.get(fieldControl.fieldKey).touched) && FormObject.get(fieldControl.fieldKey).errors">
                          <p style="color:red; margin-top:5px;"
                            *ngFor="let error of validationUtilService.getUIErrorList(FormObject.get(fieldControl.fieldKey), FORMNAME)">
                            {{error? error.errorMessage : 'Invalid Data' }}</p>
                        </ng-container>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div *ngSwitchCase="'CURRENCYINPUT'">
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24"
                        [nzRequired]="isRequired(fieldControl.fieldKey)">{{fieldControl.fieldName |
                        translate}}<span class="p-l-5 col-grey-light" nz-tooltip [nzTooltipTitle]="fieldControl.fieldDesc"
                          *ngIf="fieldControl.fieldDesc"><i nz-icon nzType="exclamation-circle"
                            class="ico-item"></i></span> <span
                          *ngIf="!fieldControl.ignoreSpellCheck && !environment.production" nz-tooltip
                          [nzTooltipTitle]="fieldControl.wrongSpellWords"
                          style="font-size: small; color: red;">{{fieldControl.fieldNameSpellCheckCorrent? '' : '[Wrong
                          Spelling]'}}</span>
                      </nz-form-label>
                      <nz-form-control [nzSpan]="24">
                        <input currencyMask type="text" [options]="currencyOptions" nz-input [maxlength]="fieldControl.maxlength"
                          [formControlName]="fieldControl.fieldKey"
                          (ngModelChange)="fieldDataChangeHandler(fieldControl.fieldGenericMapping,fieldControl.fieldKey)"
                          [readonly]="disabled || fieldControl.disabled || fieldControl.readOnly" />
                        <ng-container
                          *ngIf="FormObject.get(fieldControl.fieldKey) && (FormObject.get(fieldControl.fieldKey).dirty || FormObject.get(fieldControl.fieldKey).touched) && FormObject.get(fieldControl.fieldKey).errors">
                          <p style="color:red; margin-top:5px;"
                            *ngFor="let error of validationUtilService.getUIErrorList(FormObject.get(fieldControl.fieldKey), FORMNAME)">
                            {{error? error.errorMessage : 'Invalid Data' }}</p>
                        </ng-container>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div *ngSwitchCase="'TEXTAREA'">
                    <nz-form-label [nzSpan]="24">{{fieldControl.fieldName | translate}}<span class="p-l-5 col-grey-light"
                        nz-tooltip [nzTooltipTitle]="fieldControl.fieldDesc" *ngIf="fieldControl.fieldDesc"><i nz-icon
                          nzType="exclamation-circle" class="ico-item"></i></span> <span
                        *ngIf="!fieldControl.ignoreSpellCheck && !environment.production" nz-tooltip
                        [nzTooltipTitle]="fieldControl.wrongSpellWords"
                        style="font-size: small; color: red;">{{fieldControl.fieldNameSpellCheckCorrent? '' : '[Wrong
                        Spelling]'}}</span>
                    </nz-form-label>
                    <textarea rows="2" [maxlength]="fieldControl.maxlength" nz-input
                      [formControlName]="fieldControl.fieldKey"></textarea>
                    <p style="font-size: xx-small;">
                      {{FormObject.value[fieldControl.fieldKey]? FormObject.value[fieldControl.fieldKey].length:
                      0}}/{{fieldControl.maxlength}}
                      Characters</p>
                  </div>
                  <div *ngSwitchCase="'TIME'">
                    <nz-form-item>
                      <nz-form-label [nzFor]="fieldControl.fieldKey" [nzSpan]="24"
                        [nzRequired]="isRequired(fieldControl.fieldKey)">{{fieldControl.fieldName | translate}}<span
                          class="p-l-5 col-grey-light" nz-tooltip [nzTooltipTitle]="fieldControl.fieldDesc"
                          *ngIf="fieldControl.fieldDesc"><i nz-icon nzType="exclamation-circle"
                            class="ico-item"></i></span>
                        <span *ngIf="!fieldControl.ignoreSpellCheck && !environment.production" nz-tooltip
                          [nzTooltipTitle]="fieldControl.wrongSpellWords"
                          style="font-size: small; color: red;">{{fieldControl.fieldNameSpellCheckCorrent? '' : '[Wrong
                          Spelling]'}}</span>
                        <!--(Time of Death)-->
                      </nz-form-label>
                      <nz-form-control [nzSpan]="24">
                        <nz-time-picker [id]="fieldControl.fieldKey" [formControlName]="fieldControl.fieldKey"
                          (ngModelChange)="fieldDataChangeHandler(fieldControl.fieldGenericMapping,fieldControl.fieldKey)"
                          [nzDisabled]="disabled || fieldControl.disabled" style="width:100%" [nzFormat]="'HH:mm'">
                        </nz-time-picker>
                        <ng-container
                          *ngIf="FormObject.get(fieldControl.fieldKey) && (FormObject.get(fieldControl.fieldKey).dirty || FormObject.get(fieldControl.fieldKey).touched) && FormObject.get(fieldControl.fieldKey).errors">
                          <p style="color:red; margin-top:5px;"
                            *ngFor="let error of validationUtilService.getUIErrorList(FormObject.get(fieldControl.fieldKey), FORMNAME)">
                            {{error? error.errorMessage : 'Invalid Data' }}</p>
                        </ng-container>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div *ngSwitchCase="'CHECKBOX'">
                    <nz-form-item>
                      <nz-form-control [nzSpan]="24">
                        <label style="margin-top: 40px;" nz-checkbox [formControlName]="fieldControl.fieldKey"
                          (ngModelChange)="fieldDataChangeHandler(fieldControl.fieldGenericMapping,fieldControl.fieldKey)">
                          {{fieldControl.fieldName | translate}}
                        </label>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div *ngSwitchCase="'EMPTY'">
                  </div>
                  <div *ngSwitchCase="'DOCUMENT'">
                    <!-- Document Manager: MINI mode -->
                    <span *ngIf="!fieldControl.ignoreSpellCheck && !environment.production" nz-tooltip
                      [nzTooltipTitle]="fieldControl.wrongSpellWords"
                      style="font-size: small; color: red;">{{fieldControl.fieldNameSpellCheckCorrent? '' : '[Wrong
                      Spelling]'}}</span>
                    <app-document-manager [mode]="'mini'" [requirementCd]="fieldControl.docConfig.requirementCd"
                      [heading]="fieldControl.fieldName" [headingType]="fieldControl.docConfig.headingType"
                      [requirements]="[]" [RequirementEntityGuid]="entityGuid">
                    </app-document-manager>
                    <!-- /Document Manager -->
                  </div>
                  <div *ngSwitchCase="'RATING'">
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24">{{fieldControl.fieldName | translate}}<span
                          class="p-l-5 col-grey-light" nz-tooltip [nzTooltipTitle]="fieldControl.fieldDesc"
                          *ngIf="fieldControl.fieldDesc"><i nz-icon nzType="exclamation-circle"
                            class="ico-item"></i></span> <span
                          *ngIf="!fieldControl.ignoreSpellCheck && !environment.production" nz-tooltip
                          [nzTooltipTitle]="fieldControl.wrongSpellWords"
                          style="font-size: small; color: red;">{{fieldControl.fieldNameSpellCheckCorrent? '' : '[Wrong
                          Spelling]'}}</span>
                      </nz-form-label>
                      <nz-form-control [nzSpan]="24">
                        <nz-rate nzAllowHalf [formControlName]="fieldControl.fieldKey"
                          [nzDisabled]="fieldControl.disabled">
                        </nz-rate>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div *ngSwitchCase="'RADIO'">
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24">{{fieldControl.fieldName | translate}}<span
                          class="p-l-5 col-grey-light" nz-tooltip [nzTooltipTitle]="fieldControl.fieldDesc"
                          *ngIf="fieldControl.fieldDesc"><i nz-icon nzType="exclamation-circle"
                            class="ico-item col-grey-light"></i></span> <span
                          *ngIf="!fieldControl.ignoreSpellCheck && !environment.production" nz-tooltip
                          [nzTooltipTitle]="fieldControl.wrongSpellWords"
                          style="font-size: small; color: red;">{{fieldControl.fieldNameSpellCheckCorrent? '' : '[Wrong
                          Spelling]'}}</span>
                      </nz-form-label>
                      <nz-form-control [nzSpan]="24">
                        <nz-radio-group [formControlName]="fieldControl.fieldKey"
                          (ngModelChange)="fieldDataChangeHandler(fieldControl.fieldGenericMapping,fieldControl.fieldKey)">
                          <label nz-radio *ngFor="let item of (lookup$[fieldControl.lookupCd] | async)"
                            [nzValue]="item?.lookupKey">{{item?.lookupValue}}</label>
                        </nz-radio-group>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div *ngSwitchCase="'RADIOBUTTON'">
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24">{{fieldControl.fieldName | translate}}<span
                          class="p-l-5 col-grey-light" nz-tooltip [nzTooltipTitle]="fieldControl.fieldDesc"
                          *ngIf="fieldControl.fieldDesc"><i nz-icon nzType="exclamation-circle"
                            class="ico-item col-grey-light"></i></span> <span
                          *ngIf="!fieldControl.ignoreSpellCheck && !environment.production" nz-tooltip
                          [nzTooltipTitle]="fieldControl.wrongSpellWords"
                          style="font-size: small; color: red;">{{fieldControl.fieldNameSpellCheckCorrent? '' : '[Wrong
                          Spelling]'}}</span>
                      </nz-form-label>
                      <nz-form-control [nzSpan]="24">
                        <nz-radio-group [formControlName]="fieldControl.fieldKey"
                          (ngModelChange)="fieldDataChangeHandler(fieldControl.fieldGenericMapping,fieldControl.fieldKey)"
                          [nzButtonStyle]="'solid'">
                          <label nz-radio-button *ngFor="let item of (lookup$[fieldControl.lookupCd] | async)"
                            [nzValue]="item?.lookupKey">{{item?.lookupValue}}</label>
                        </nz-radio-group>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div *ngSwitchCase="'QR'">
                    <h4>{{fieldControl.fieldName | MMSTranslate}}</h4>
                    <qrcode [qrdata]="fieldControl.value.fieldKey" [width]="256" [errorCorrectionLevel]="'M'"
                      [elementType]="'svg'"></qrcode>
                  </div>
                  <!--Health claims specific  -->
                <div *ngSwitchCase="'BIGINPUT'">
                  <nz-form-item>
                    <nz-form-label [nzSpan]="24" [nzRequired]="isRequired(fieldControl.fieldKey)">{{fieldControl.fieldName | MMSTranslate}} <span
                        *ngIf="!fieldControl.ignoreSpellCheck && !environment.production" nz-tooltip
                        [nzTooltipTitle]="fieldControl.wrongSpellWords"
                        style="font-size: small; color: red;">{{fieldControl.fieldNameSpellCheckCorrent? '' : '[Wrong
                        Spelling]'}}</span>
                    </nz-form-label>
                    <nz-form-control [nzSpan]="24">
                      <input nz-input [formControlName]="fieldControl.fieldKey" [maxlength]="fieldControl.maxlength"
                        (ngModelChange)="fieldDataChangeHandler(fieldControl.fieldGenericMapping,fieldControl.fieldKey)"
                        [readonly]="disabled || fieldControl.disabled" />
                      <ng-container
                        *ngIf="FormObject.get(fieldControl.fieldKey) && (FormObject.get(fieldControl.fieldKey).dirty || FormObject.get(fieldControl.fieldKey).touched) && FormObject.get(fieldControl.fieldKey).errors">
                        <p style="color:red; margin-top:5px;"
                          *ngFor="let error of validationUtilService.getUIErrorList(FormObject.get(fieldControl.fieldKey), FORMNAME)">
                          {{error? error.errorMessage : 'Invalid Data' }}</p>
                      </ng-container>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div *ngSwitchCase="'SEARCHNLINK'">
                  <nz-form-label class="d-b" [nzSpan]="24" [nzRequired]="isRequired(fieldControl.fieldKey)">{{fieldControl.fieldName |
                    MMSTranslate}} <span *ngIf="!fieldControl.ignoreSpellCheck && !environment.production" nz-tooltip
                      [nzTooltipTitle]="fieldControl.wrongSpellWords"
                      style="font-size: small; color: red;">{{fieldControl.fieldNameSpellCheckCorrent? '' : '[Wrong
                      Spelling]'}}</span>
                    </nz-form-label>
                    <!-- <br/> -->
                  <app-search-and-link [UIConfiguration]="fieldControl.configParams"
                    [searchedAndLinkedData]="FormObject.value[fieldControl.fieldKey]"
                    (searchAndLinkOutput)="setSearchAndLinkOutput($event, fieldControl.fieldKey)"></app-search-and-link>
                </div>
                  <div *ngSwitchDefault> 
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24">{{fieldControl.fieldName | translate}} <span class="p-l-5 col-grey-light" nz-tooltip
                          [nzTooltipTitle]="fieldControl.fieldDesc" *ngIf="fieldControl.fieldDesc"><i nz-icon
                            nzType="exclamation-circle" class="ico-item"></i></span>
                      </nz-form-label>
                      <nz-form-control [nzSpan]="24">
                        <span style="color: red;">Unsupported field type metadata.</span>
                      </nz-form-control>
                    </nz-form-item>
                    </div>
  
  
                  <!-- NOT PART OF SWITCH: This will always be last -->
                  <ng-container *ngIf="fieldControl.lineBreakAfterThisField">
                    <br>
                  </ng-container>
  
                </div>
              </ng-container>
            </div>
          </form>
        </nz-collapse-panel>
      </nz-collapse>
    </ng-container>
    <p *ngIf="!metaDataValid">Metadata Unsupported</p>
  </nz-skeleton>
  <!-- </ng-container> -->
  <!-- <ng-template #componentNameNotAvailable>
      Component not rendered because either currentComponentName Attribute missing or Form has not been initialized on
      DynamicFormComponent.
    </ng-template> -->